import ApiService from '@/common/api.service'
import * as action from '@/store/action.types'
import * as mutation from '@/store/mutation.types'
import { CALENDAR_VIEW_MODES } from '@/constants/CalendarConsts'
import { 
  FETCH_CALENDAR_DATA_URL 
} from '@/constants/ApiConstants'
import { SESSION_TYPES } from '@/constants/SessionConsts'

const initialState = {
  viewDate: new Date(),
  allEvents: [],
  events: [],
  selectedSessionTypes: [SESSION_TYPES.GAME, SESSION_TYPES.TRAINING, SESSION_TYPES.OTHER, SESSION_TYPES.INDIVIDUAL],
  teams: [],
  selectedTeams: [],
  calendarTeamsFetched: false,
  previewMode: CALENDAR_VIEW_MODES.MONTH,
}

const getDefaultState = () => {
  return {
    ...initialState
  }
}

const state = {
  ...getDefaultState()
}

const getters = {
  viewDate: state => state.viewDate,
  allEvents: state => state.allEvents,
  events: state => state.events,
  selectedSessionTypes: state => state.selectedSessionTypes,
  calendarTeams: state => state.teams,
  calendarSelectedTeams: state => state.selectedTeams,
  calendarTeamsFetched: state => state.calendarTeamsFetched,
  calendarPreviewMode: state => state.previewMode,
  startDate: state => state.startDate,
  endDate: state => state.endDate
}

const actions = {
  [action.FETCH_CALENDAR_DATA] ({ commit, state }, { payload, playerId }) {
    return new Promise((resolve, reject) => {
      ApiService
        .get(`${FETCH_CALENDAR_DATA_URL.replace(':playerId', playerId)}`, payload)
        .then(({data}) => {
          commit(mutation.SET_CALENDAR_EVENTS, data.dailyTeamActivities)
 
          commit(mutation.UPDATE_LIST_OF_CALENDAR_TEAMS, { payload: data.teams })
         
          commit(mutation.FILTER_CALENDAR_EVENTS)

          return resolve(data)
        })
        .catch(error => reject(error))
    })
  },
  [action.CHANGE_LIST_OF_SELECTED_CALENDAR_TEAMS] ({ commit }, payload) {
    commit(mutation.UPDATE_LIST_OF_SELECTED_CALENDAR_TEAMS, { payload })
    commit(mutation.FILTER_CALENDAR_EVENTS)
    commit(mutation.UPDATE_CALENDAR_STORAGE)
  },
  [action.CHANGE_CALENDAR_SESSION_TYPES] ({ commit }, payload) {
    commit(mutation.CHANGE_CALENDAR_SESSION_TYPES, payload)
    commit(mutation.FILTER_CALENDAR_EVENTS)
    commit(mutation.UPDATE_CALENDAR_STORAGE)
  },
  [action.UPDATE_CALENDAR_STORAGE] ({ commit }) {
    commit(mutation.UPDATE_CALENDAR_STORAGE)
  },
  [action.UPDATE_PREVIEW_MODE] ({ commit }, newPreviewMode) {
    commit(mutation.UPDATE_PREVIEW_MODE, newPreviewMode)
    commit(mutation.UPDATE_CALENDAR_STORAGE)
  },
  [action.FETCH_FILTER_DATA_FROM_STORAGE] ({ commit }) {
    commit(mutation.UPDATE_CALENDAR_STORAGE)
    commit(mutation.UPDATE_FILTER_DATA_FROM_STORAGE)
  },
  [action.UPDATE_VIEW_DATE] ({ commit }, newDate) {
    commit(mutation.UPDATE_VIEW_DATE, newDate)
    commit(mutation.UPDATE_CALENDAR_STORAGE)
  },
  [action.RESET_STATE] ({ commit }) {
    commit(mutation.RESET_STATE)
  }
}

const mutations = {
  [mutation.SET_CALENDAR_EVENTS] (state, payload) {
    state.allEvents = payload
  },
  [mutation.FILTER_CALENDAR_EVENTS] (state) {
    state.events = state.allEvents.filter(sessionEvent => {
      if (sessionEvent.type === SESSION_TYPES.INDIVIDUAL && state.selectedSessionTypes.indexOf(sessionEvent.type) >= 0) {
        return sessionEvent
      }
      
      return (
        state.selectedSessionTypes.indexOf(sessionEvent.type) >= 0 &&
        state.selectedTeams.some(t => t.teamId === sessionEvent.teamId)
      )
    })
  },
  [mutation.CHANGE_CALENDAR_SESSION_TYPES] (state, { payload }) {
    if(payload.isAdding && state.selectedSessionTypes.indexOf(payload.type) < 0) {
      state.selectedSessionTypes.push(payload.type)
    } else if (!payload.isAdding) {
      state.selectedSessionTypes = state.selectedSessionTypes.filter(t => {
        return t !== payload.type
      })
    }
  },
  [mutation.UPDATE_LIST_OF_SELECTED_CALENDAR_TEAMS] (state, { payload }) {
    state.selectedTeams = payload
  },
  [mutation.UPDATE_LIST_OF_CALENDAR_TEAMS] (state, { payload }) {
    state.calendarTeamsFetched = true
    state.teams = payload
    state.selectedTeams = payload
  },
  [mutation.UPDATE_CALENDAR_STORAGE] (state) {
    window.localStorage.setItem('calendarFilterData', JSON.stringify({
      selectedSessionTypes: state.selectedSessionTypes,
      selectedTeams: state.selectedTeams,
      previewMode: state.previewMode,
      viewDate: state.viewDate
    }))
  },
  [mutation.UPDATE_PREVIEW_MODE] (state, newPreviewMode) {
    state.previewMode = newPreviewMode
  },
  [mutation.UPDATE_FILTER_DATA_FROM_STORAGE] (state) {
    const { 
      selectedSessionTypes, 
      selectedTeams, 
      previewMode, 
      viewDate
    } = JSON.parse(window.localStorage.getItem('calendarFilterData'));

    const calendarDate = new Date(viewDate)

    state.selectedSessionTypes = selectedSessionTypes
    state.selectedTeams = selectedTeams
    state.previewMode = previewMode
    state.viewDate = new Date(Date.UTC(calendarDate.getFullYear(), calendarDate.getMonth(), calendarDate.getDate(), 0, 0, 0))
  },
  [mutation.UPDATE_VIEW_DATE] (state, newViewDate) {
    state.viewDate = newViewDate
  },
  [mutation.RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
}

export default {
  state,
  actions,
  mutations,
  getters
}
